var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 92,
    height: 92,
    rx: 46,
    fill: "#E7454C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_Line Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 27V58C23 62.4183 26.5817 66 31 66H69",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M24.5 27V58C24.5 61.5118 27.285 64.3731 30.7669 64.4959L31 64.5H69V67.5H31C25.8438 67.5 21.647 63.3921 21.5038 58.2705L21.5 58V27H24.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M65.78 30.19L68.305 31.81L54.884 52.7284C54.4022 53.4793 53.3854 53.6386 52.6993 53.1016L52.5881 53.0057L43.123 44.01L34.2778 56.851L31.8073 55.149L41.6494 40.8633C42.1433 40.1464 43.1318 40.0065 43.803 40.5281L43.918 40.627L53.339 49.581L65.78 30.19Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTec);
export default __webpack_public_path__ + "static/media/tec.2203bbc4ffaa5bcedb76cdd9558a7ada.svg";
export { ForwardRef as ReactComponent };